/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InfantSixYearOld } from './InfantSixYearOld';
import {
    InfantSixYearOldFromJSON,
    InfantSixYearOldFromJSONTyped,
    InfantSixYearOldToJSON,
} from './InfantSixYearOld';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface InfantSixYearOldPagination
 */
export interface InfantSixYearOldPagination {
    /**
     * 
     * @type {Array<InfantSixYearOld>}
     * @memberof InfantSixYearOldPagination
     */
    data?: Array<InfantSixYearOld>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof InfantSixYearOldPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the InfantSixYearOldPagination interface.
 */
export function instanceOfInfantSixYearOldPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InfantSixYearOldPaginationFromJSON(json: any): InfantSixYearOldPagination {
    return InfantSixYearOldPaginationFromJSONTyped(json, false);
}

export function InfantSixYearOldPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfantSixYearOldPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(InfantSixYearOldFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function InfantSixYearOldPaginationToJSON(value?: InfantSixYearOldPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(InfantSixYearOldToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

